import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { config } from '../config';
import { tap, catchError } from 'rxjs/operators';
import { User } from '../model/user';

import { Router } from '@angular/router';
import { timeout } from 'rxjs/operators';
import { Wait } from '../util/timeout';
import { ErrorHandlerService } from './errorHandler.service';
import { Cacheable } from 'ngx-cacheable';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient, private router: Router, private handleError: ErrorHandlerService) { }

  getAll(): Observable<[]> {
    return this.http.get<any>(`${config.apiUrl}/Users`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          if (error.message == 'Timeout has occurred') {
            this.handleError.toastTimeout('Demora na comunicação com servidor');
          }
          return of([]);
        }));
  }

  @Cacheable({
    maxCacheCount: 2000,
    maxAge: 3600000,
  })
  getThumbnail(userId, update): Observable < any > {
    return this.http.get<any>(`${config.apiUrl}/Users/${userId}/thumbnail?${update}`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  @Cacheable({
    maxCacheCount: 2000,
    maxAge: 3600000,
  })
  getQrCode(userId): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Users/${userId}/QrCode`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }
  
  getUserName(userId): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/Users/${userId}/Name`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  @Cacheable({
    maxCacheCount: 2000,
    maxAge: 300000,
  })
  getById(userId: number): Observable<User | null> {
    return this.http.get<any>(`${config.apiUrl}/Users/${userId}`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of(null);
        }));
  }

  getByRfid(rfid): any {
    return this.http.get<any>(`${config.apiUrl}/Users/rfid/${rfid}`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of(undefined);
        }));
  }

  getByDocument(document): Observable<[]> {
    return this.http.get<any>(`${config.apiUrl}/Users/document/${document}`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          throw (error)
        }));
  }

  addNew(user: User): Observable<any> {
    return this.http.post<any>(`${config.apiUrl}/Users/`, user)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possível adicionar novo usuário');
          return of(false);
        }));
  }

  update(user: User): Observable<any> {
    return this.http.put<any>(`${config.apiUrl}/Users/${user.id}`, user)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possível atualizar os dados do usuário');
          return of(false);
        }));
  }

  acceptTermsOfUse(userId: number): Observable<any> {
    return this.http.post<any>(`${config.apiUrl}/Users/LicenseTermsAccepted`, userId)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possível fazer o aceite dos termos');
          return of(false);
        }));
  }

    getTemporaryBadgesReport(options: any): Observable<[]> {
    let params = new HttpParams()
      .set("startAt", options.startAt)
      .set("endAt", options.endAt)
      .set("nameDocRfid", options.nameDocRfid);
      
    return this.http.get<any>(`${config.apiUrl}/Users/tmpRfidCard`, { params: params })
      .pipe(timeout(Wait),
        tap(resp => {
          if (Array.isArray(resp)) {
            resp.forEach(item => {
              if (item.rfidCardCode) {
                item.rfidCardCode = `${item.rfidCardCode} / ${parseInt(item.rfidCardCode, 16)}`;
              }
              if (item.tmpRfidCardCode) {
                item.tmpRfidCardCode = `${item.tmpRfidCardCode} / ${parseInt(item.tmpRfidCardCode, 16)}`;
              }
            });
          }
        }),
        catchError(error => {
          console.log(error.error);
          this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possível resgatar os dados para o relatório de cartões temporários');
          return of([]);
        }));
  }

}
